import { db } from '../config/firebase';
import { collection, addDoc, serverTimestamp, getDocs, query, limit, deleteDoc } from '../config/firebase';
import { toast } from 'sonner';

// Sample events with current year
const currentYear = new Date().getFullYear();
const SAMPLE_EVENTS = [
  {
    title: 'Summer Music Festival',
    description: 'Join us for a weekend of amazing music performances featuring top artists from around the world.',
    date: `Aug 15, ${currentYear}`,
    time: '12:00 PM - 10:00 PM',
    location: 'Central Park, New York',
    category: 'Music',
    imageUrl: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 75.99,
    capacity: 5000,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['music', 'festival', 'concert', 'summer'],
  },
  {
    title: 'Tech Conference 2024',
    description: 'Discover the latest innovations in technology with industry leaders and workshops.',
    date: `Sep 5, ${currentYear}`,
    time: '9:00 AM - 5:00 PM',
    location: 'Convention Center, San Francisco',
    category: 'Technology',
    imageUrl: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 199.99,
    capacity: 1000,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['technology', 'conference', 'workshop', 'innovation'],
  },
  {
    title: 'Food & Wine Expo',
    description: 'Taste exquisite cuisine and fine wines from renowned chefs and sommeliers.',
    date: `Oct 12, ${currentYear}`,
    time: '11:00 AM - 8:00 PM',
    location: 'Grand Hall, Chicago',
    category: 'Food',
    imageUrl: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 49.99,
    capacity: 2000,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['food', 'wine', 'culinary', 'tasting'],
  },
  {
    title: 'Business Leadership Summit',
    description: 'Connect with industry leaders and learn strategies for business growth and leadership excellence.',
    date: `Nov 8, ${currentYear}`,
    time: '8:30 AM - 4:30 PM',
    location: 'Marriott Downtown, Seattle',
    category: 'Business',
    imageUrl: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 249.99,
    capacity: 500,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['business', 'leadership', 'networking', 'professional'],
  },
  {
    title: 'Art Gallery Opening Night',
    description: 'Be among the first to experience the stunning new exhibition featuring contemporary artists.',
    date: `Dec 3, ${currentYear}`,
    time: '7:00 PM - 10:00 PM',
    location: 'Modern Art Gallery, Boston',
    category: 'Arts',
    imageUrl: 'https://images.unsplash.com/photo-1531058020387-3be344556be6?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 25.00,
    capacity: 200,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['art', 'gallery', 'exhibition', 'culture'],
  },
  // Adding 25 more events to make a total of 30
  {
    title: 'Yoga & Wellness Retreat',
    description: 'A weekend of relaxation, yoga, and mindfulness in a serene natural setting.',
    date: `Jul 18, ${currentYear}`,
    time: '8:00 AM - 6:00 PM',
    location: 'Mountain View Resort, Colorado',
    category: 'Health',
    imageUrl: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 149.99,
    capacity: 100,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['yoga', 'wellness', 'retreat', 'health'],
  },
  {
    title: 'Comedy Night Spectacular',
    description: 'Laugh the night away with performances from top stand-up comedians.',
    date: `Aug 25, ${currentYear}`,
    time: '8:00 PM - 11:00 PM',
    location: 'Laugh Factory, Los Angeles',
    category: 'Entertainment',
    imageUrl: 'https://images.unsplash.com/photo-1527224857830-43a7acc85260?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 35.00,
    capacity: 300,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['comedy', 'standup', 'entertainment', 'nightlife'],
  },
  {
    title: 'Craft Beer Festival',
    description: 'Sample over 100 craft beers from local and regional breweries.',
    date: `Sep 19, ${currentYear}`,
    time: '12:00 PM - 7:00 PM',
    location: 'Waterfront Park, Portland',
    category: 'Food & Drink',
    imageUrl: 'https://images.unsplash.com/photo-1514933651103-005eec06c04b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 45.00,
    capacity: 1500,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['beer', 'craft', 'festival', 'tasting'],
  },
  {
    title: 'Digital Marketing Workshop',
    description: 'Learn advanced digital marketing strategies from industry experts.',
    date: `Oct 7, ${currentYear}`,
    time: '9:00 AM - 4:00 PM',
    location: 'Business Hub, Austin',
    category: 'Education',
    imageUrl: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 129.99,
    capacity: 150,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['marketing', 'digital', 'workshop', 'business'],
  },
  {
    title: 'International Film Festival',
    description: 'A showcase of award-winning films from around the world with director Q&As.',
    date: `Nov 14, ${currentYear}`,
    time: '10:00 AM - 11:00 PM',
    location: 'Cinema Complex, Toronto',
    category: 'Film',
    imageUrl: 'https://images.unsplash.com/photo-1485095329183-d0797cdc5676?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 65.00,
    capacity: 800,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['film', 'festival', 'international', 'cinema'],
  },
  {
    title: 'Photography Exhibition',
    description: 'Stunning photography from acclaimed international photographers.',
    date: `Jul 22, ${currentYear}`,
    time: '10:00 AM - 6:00 PM',
    location: 'City Gallery, Miami',
    category: 'Arts',
    imageUrl: 'https://images.unsplash.com/photo-1554048612-b6a482bc67e5?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 15.00,
    capacity: 250,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['photography', 'art', 'exhibition', 'visual'],
  },
  {
    title: 'Blockchain & Cryptocurrency Summit',
    description: 'Explore the future of blockchain technology and digital currencies.',
    date: `Aug 30, ${currentYear}`,
    time: '9:00 AM - 6:00 PM',
    location: 'Tech Center, Singapore',
    category: 'Technology',
    imageUrl: 'https://images.unsplash.com/photo-1516245834210-c4c142787335?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 179.99,
    capacity: 600,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['blockchain', 'crypto', 'technology', 'finance'],
  },
  {
    title: 'Charity Gala Dinner',
    description: 'An elegant evening supporting children\'s education in underserved communities.',
    date: `Sep 22, ${currentYear}`,
    time: '7:00 PM - 11:00 PM',
    location: 'Grand Ballroom, The Ritz, Dallas',
    category: 'Charity',
    imageUrl: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 299.99,
    capacity: 400,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['charity', 'gala', 'fundraiser', 'education'],
  },
  {
    title: 'Marathon City Run',
    description: 'Join thousands of runners in this annual city marathon for all fitness levels.',
    date: `Oct 15, ${currentYear}`,
    time: '7:00 AM - 2:00 PM',
    location: 'Downtown, Philadelphia',
    category: 'Sports',
    imageUrl: 'https://images.unsplash.com/photo-1530549387789-4c1017266635?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 59.99,
    capacity: 10000,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['marathon', 'running', 'sports', 'fitness'],
  },
  {
    title: 'Home & Garden Expo',
    description: 'Discover the latest trends in home decoration, renovation, and gardening.',
    date: `May 18, ${currentYear}`,
    time: '10:00 AM - 8:00 PM',
    location: 'Exhibition Center, Atlanta',
    category: 'Lifestyle',
    imageUrl: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 22.50,
    capacity: 3000,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['home', 'garden', 'decoration', 'lifestyle'],
  },
  {
    title: 'Science Fiction Convention',
    description: 'The ultimate gathering for sci-fi enthusiasts with celebrity guests, panels, and cosplay.',
    date: `Jul 28, ${currentYear}`,
    time: '9:00 AM - 7:00 PM',
    location: 'Convention Center, Denver',
    category: 'Entertainment',
    imageUrl: 'https://images.unsplash.com/photo-1535016120720-40c646be5580?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 85.00,
    capacity: 5000,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['sci-fi', 'convention', 'cosplay', 'entertainment'],
  },
  {
    title: 'Culinary Masterclass',
    description: 'Learn culinary secrets from Michelin-starred chefs in this hands-on cooking class.',
    date: `Jun 12, ${currentYear}`,
    time: '10:00 AM - 2:00 PM',
    location: 'Gourmet Kitchen, New Orleans',
    category: 'Food',
    imageUrl: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 195.00,
    capacity: 40,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['cooking', 'culinary', 'masterclass', 'chef'],
  },
  {
    title: 'Vintage Car Show',
    description: 'Admire classic and vintage automobiles from collectors across the country.',
    date: `Aug 5, ${currentYear}`,
    time: '11:00 AM - 5:00 PM',
    location: 'Fairgrounds, Detroit',
    category: 'Automotive',
    imageUrl: 'https://images.unsplash.com/photo-1583121274602-3e2820c69888?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 29.99,
    capacity: 2500,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['cars', 'vintage', 'automotive', 'classic'],
  },
  {
    title: 'Fashion Week',
    description: 'Experience cutting-edge fashion from emerging and established designers.',
    date: `Sep 15, ${currentYear}`,
    time: '6:00 PM - 10:00 PM',
    location: 'Fashion Pavilion, New York',
    category: 'Fashion',
    imageUrl: 'https://images.unsplash.com/photo-1509631179647-0177331693ae?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 120.00,
    capacity: 800,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['fashion', 'runway', 'design', 'style'],
  },
  {
    title: 'Electronic Music Festival',
    description: 'Three days of performances by world-class DJs and electronic music artists.',
    date: `Jul 8, ${currentYear}`,
    time: '3:00 PM - 2:00 AM',
    location: 'Beachfront, Miami',
    category: 'Music',
    imageUrl: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 189.99,
    capacity: 8000,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['electronic', 'music', 'festival', 'dj'],
  },
  {
    title: 'Sustainable Living Expo',
    description: 'Discover eco-friendly products and learn about sustainable living practices.',
    date: `May 28, ${currentYear}`,
    time: '10:00 AM - 6:00 PM',
    location: 'Community Center, Portland',
    category: 'Environment',
    imageUrl: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 15.00,
    capacity: 1200,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['sustainable', 'eco', 'green', 'environment'],
  },
  {
    title: 'Children\'s Book Festival',
    description: 'A magical day of storytelling, author readings, and book-related activities for kids.',
    date: `Jun 25, ${currentYear}`,
    time: '9:00 AM - 4:00 PM',
    location: 'Public Library, Chicago',
    category: 'Family',
    imageUrl: 'https://images.unsplash.com/photo-1529148482759-b35b25c5f217?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 10.00,
    capacity: 400,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['books', 'children', 'reading', 'family'],
  },
  {
    title: 'Robotics Competition',
    description: 'Watch teams compete in designing and programming robots for various challenges.',
    date: `Nov 22, ${currentYear}`,
    time: '10:00 AM - 6:00 PM',
    location: 'Science Center, Boston',
    category: 'Technology',
    imageUrl: 'https://images.unsplash.com/photo-1531746790731-6c087fecd65a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 18.50,
    capacity: 600,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['robotics', 'technology', 'competition', 'science'],
  },
  {
    title: 'Wedding Expo',
    description: 'Everything you need for your perfect wedding day under one roof.',
    date: `Feb 15, ${currentYear}`,
    time: '11:00 AM - 7:00 PM',
    location: 'Grand Hotel, Las Vegas',
    category: 'Lifestyle',
    imageUrl: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 25.00,
    capacity: 1500,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['wedding', 'bridal', 'expo', 'planning'],
  },
  {
    title: 'Jazz in the Park',
    description: 'An evening of smooth jazz performed by acclaimed musicians in a beautiful park setting.',
    date: `Jul 30, ${currentYear}`,
    time: '6:00 PM - 9:00 PM',
    location: 'Riverside Park, New Orleans',
    category: 'Music',
    imageUrl: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 30.00,
    capacity: 1000,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['jazz', 'music', 'park', 'concert'],
  },
  {
    title: 'Health & Fitness Expo',
    description: 'Discover the latest in health, fitness, and nutrition with experts and demonstrations.',
    date: `Apr 20, ${currentYear}`,
    time: '9:00 AM - 5:00 PM',
    location: 'Sports Arena, San Diego',
    category: 'Health',
    imageUrl: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 22.00,
    capacity: 2000,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['fitness', 'health', 'wellness', 'nutrition'],
  },
  {
    title: 'Urban Street Art Festival',
    description: 'Celebrate street art with live painting, murals, and performances by urban artists.',
    date: `Jun 8, ${currentYear}`,
    time: '12:00 PM - 9:00 PM',
    location: 'Downtown District, Austin',
    category: 'Arts',
    imageUrl: 'https://images.unsplash.com/photo-1499781350541-7783f6c6a0c8?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 0.00,
    capacity: 5000,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['street art', 'urban', 'graffiti', 'cultural'],
  },
  {
    title: 'Classic Literature Book Club',
    description: 'Join fellow literature enthusiasts in discussing timeless literary masterpieces.',
    date: `Aug 12, ${currentYear}`,
    time: '7:00 PM - 9:00 PM',
    location: 'Vintage Bookstore, Seattle',
    category: 'Education',
    imageUrl: 'https://images.unsplash.com/photo-1526243741027-444d633d7365?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 5.00,
    capacity: 30,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['books', 'literature', 'reading', 'discussion'],
  },
  {
    title: 'Virtual Reality Gaming Tournament',
    description: 'Compete in cutting-edge VR games for prizes and gaming glory.',
    date: `Oct 28, ${currentYear}`,
    time: '10:00 AM - 8:00 PM',
    location: 'Gaming Arena, Los Angeles',
    category: 'Gaming',
    imageUrl: 'https://images.unsplash.com/photo-1592478411213-6153e4ebc07d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 45.00,
    capacity: 200,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['gaming', 'VR', 'tournament', 'technology'],
  },
  {
    title: 'Comedy Improv Night',
    description: 'An evening of laughter with talented improvisational comedians.',
    date: `Sep 2, ${currentYear}`,
    time: '8:00 PM - 10:30 PM',
    location: 'Comedy Club, Chicago',
    category: 'Entertainment',
    imageUrl: 'https://images.unsplash.com/photo-1585647347483-22b66260dfff?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 25.00,
    capacity: 150,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['comedy', 'improv', 'entertainment', 'nightlife'],
  },
  {
    title: 'Winter Sports Expo',
    description: 'Everything for winter sports enthusiasts with equipment demos and expert advice.',
    date: `Nov 5, ${currentYear}`,
    time: '10:00 AM - 6:00 PM',
    location: 'Mountain Convention Center, Denver',
    category: 'Sports',
    imageUrl: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 35.00,
    capacity: 1800,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    organizerId: 'system',
    status: 'published',
    tags: ['winter', 'sports', 'skiing', 'snowboarding'],
  }
];

// Generate a total of 30 diverse events
const generateEvents = () => {
  const categories = ['Music', 'Technology', 'Food', 'Arts', 'Business', 'Sports', 'Education', 'Health', 'Entertainment'];
  const cities = ['New York', 'Los Angeles', 'Chicago', 'Miami', 'Seattle', 'Austin', 'Boston', 'San Francisco', 'Denver', 'Portland'];
  const venues = ['Convention Center', 'Concert Hall', 'Stadium', 'Park', 'Theater', 'Museum', 'Gallery', 'University', 'Hotel'];
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  
  const events = [];
  
  // Add original 5 sample events first
  events.push(...SAMPLE_EVENTS);
  
  // Generate 25 more events to reach a total of 30
  for (let i = 0; i < 25; i++) {
    const categoryIndex = i % categories.length;
    const cityIndex = i % cities.length;
    const venueIndex = i % venues.length;
    const monthIndex = i % months.length;
    const day = (i % 28) + 1;
    
    const category = categories[categoryIndex];
    const city = cities[cityIndex];
    const venue = venues[venueIndex];
    const month = months[monthIndex];
    
    events.push({
      title: `${category} Expo ${currentYear} - ${city}`,
      description: `Join us for the premier ${category.toLowerCase()} event in ${city}. Network with professionals, discover new trends, and enjoy a day of ${category.toLowerCase()}-related activities.`,
      date: `${month} ${day}, ${currentYear}`,
      time: `${10 + (i % 8)}:00 AM - ${4 + (i % 6)}:00 PM`,
      location: `${city} ${venue}`,
      category: category,
      imageUrl: `https://source.unsplash.com/random/800x600?${category.toLowerCase()}`,
      price: Math.floor(Math.random() * 150) + 25,
      capacity: Math.floor(Math.random() * 1000) + 100,
      soldTickets: Math.floor(Math.random() * 50),
      totalTickets: 500,
      revenue: Math.floor(Math.random() * 5000) + 1000,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      organizerId: 'system',
      organizerName: 'System Administrator',
      status: 'published',
      tags: [category.toLowerCase(), city.toLowerCase(), 'event', `${currentYear}`]
    });
  }
  
  return events;
};

// Check if events collection is empty
export const checkAndSeedEvents = async () => {
  try {
    const eventsRef = collection(db, 'events');
    const eventsQuery = query(eventsRef, limit(1));
    const snapshot = await getDocs(eventsQuery);
    
    if (snapshot.empty) {
      console.log('Events collection is empty, needs seeding');
      return true;
    }
    
    console.log('Events collection has data, no need to seed');
    return false;
  } catch (error) {
    console.error('Error checking events collection:', error);
    toast.error('Failed to check events collection');
    return false;
  }
};

// Clear all events from Firestore (use with caution)
export const clearEvents = async () => {
  try {
    const eventsRef = collection(db, 'events');
    const snapshot = await getDocs(eventsRef);
    
    if (snapshot.empty) {
      toast.info('No events to clear');
      return true;
    }
    
    const deletePromises = snapshot.docs.map(doc => deleteDoc(doc.ref));
    await Promise.all(deletePromises);
    
    toast.success(`Cleared ${snapshot.docs.length} events from the database`);
    return true;
  } catch (error) {
    console.error('Error clearing events:', error);
    toast.error('Failed to clear events');
    return false;
  }
};

// Add sample events to Firestore
export const seedEvents = async (forceReplace = false) => {
  try {
    const eventsRef = collection(db, 'events');
    
    // Check if collection already has data
    const needsSeeding = await checkAndSeedEvents();
    if (!needsSeeding && !forceReplace) {
      console.log('Events collection already has data, skipping seeding');
      return false;
    }
    
    // If forceReplace is true, clear existing events
    if (forceReplace && !needsSeeding) {
      await clearEvents();
    }
    
    // Generate 30 events
    const allEvents = generateEvents();
    
    // Add all events
    let count = 0;
    const batchSize = 5; // Add events in smaller batches to prevent timeouts
    
    for (let i = 0; i < allEvents.length; i += batchSize) {
      const batch = allEvents.slice(i, i + batchSize);
      const addPromises = batch.map(event => addDoc(eventsRef, event));
      await Promise.all(addPromises);
      count += batch.length;
      console.log(`Added batch of events (${count}/${allEvents.length})`);
    }
    
    toast.success(`Added ${count} sample events to the database`);
    console.log(`Added ${count} sample events to Firestore`);
    return true;
  } catch (error) {
    console.error('Error seeding events:', error);
    toast.error('Failed to add sample events');
    return false;
  }
}; 